import { IDeleteDependenteUseCase } from "../../../presentation/useCases/delete/delete_dependente_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteDependenteUseCase
 */

export class DeleteDependenteUseCase implements IDeleteDependenteUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteDependente(idDependente: number): Promise<void> {
    await this.repository.deleteDependente(idDependente);
  }
}